<template>
  <div
    v-if="(room.ratePlan || room.inventory > 0) && room.active"
    class="retail-room-card-container"
  >
    <div class="retail-room-details">
      <div class="retail-room-title">
        <h3>{{ room.name }}</h3>
      </div>
      <p
        v-if="hotel.contracted && notEnoughRooms"
        class="contracted-rooms-remaining"
      >
        {{ room.inventory == 1 ? $t('h4h.roomRemaining', {
          quantity: room.inventory
        }) : $t('h4h.roomsRemaining', {
          quantity: room.inventory
        }) }}
      </p>
      <p>{{ room.description }}</p>
    </div>
    <div class="retail-room-purchasing">
      <div class="retail-room-pricing">
        <span
          class="price"
        >
          <b>
            <CurrencyConvert
              :amount="room.total / stayDuration"
              :currency="'USD'"
            />
          </b>
        </span>
        <span class="total-price">
          <CurrencyConvert
            :amount="room.total"
            :currency="'USD'"
          />
          <span class="hotel-show-stay-length">
            {{ $t('h4h.roomTotal', {
              quantity: stayDuration
            }) }}
          </span>
        </span>
      </div>
      <div
        class="btn btn-secondary btn-size"
        :class="disableButton ? 'btn-disabled' : ''"
        :disable="disableButton || disableForSubmission"
        @click="changeOrderItem()"
      >
        {{ $t('h4h.selectRoom') }}
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../../cart/cart_api'
import { CurrencyConvert } from '../../../default/currency_convert'
import { mapState } from 'vuex'

export default {
  components: {
    CurrencyConvert
  },

  props: {
    checkIn: {
      type: String,
      default: null
    },
    checkOut: {
      type: String,
      default: null
    },
    hotelId: {
      type: Number,
      default: null
    },
    room: {
      type: Object,
      default: null
    },
    stayDuration: {
      type: Number,
      default: null
    },
  },

  data() {
    return {
      disableForSubmission: false
    }
  },

  computed: {
    ...mapState('hotel', {
      hotel: state => state.hotel,
      roomQty: state => state.roomQty
    }),
    notEnoughRooms() {
      return this.room.inventory <= this.$store.state.packages.packageQty
    },
    disableButton() {
      return this.roomQty > this.room.inventory ? true : false
    }
  },

  created() {
    Api.getOrder().then(order => {
      let chosenPackage=order.items.find(orderItem=>{
        return orderItem.id==window.location.pathname.match(/items\/(\d+)/)[1]
      })
      this.packageId=chosenPackage.package_id
      this.packageQty=order.item_count
      this.orderId=order.id
      this.orderItemId=chosenPackage.id
    })
  },

  methods: {
    postRetailBody(amount) {
      return JSON.stringify({
        order_item: {
          city: this.hotel.city,
          contracted: this.hotel.contracted,
          hotel_address: this.hotel.addressOne,
          hotel_check_in_date:this.checkIn,
          hotel_check_out_date:this.checkOut,
          hotel_check_in_time: this.hotel.checkInTime,
          hotel_check_out_time: this.hotel.checkOutTime,
          hotel_id: this.hotel.id,
          hotel_latitude: this.hotel.latitude,
          hotel_longitude: this.hotel.longitude,
          hotel_name: this.hotel.name,
          hotel_phone: this.hotel.phone,
          hotel_state: this.hotel.state,
          hotel_total_price: amount,
          hotel_zip: this.hotel.zip,
          id: this.orderItemId,
          package_id: this.packageId,
          quantity: this.packageQty,
          room_quantity: this.$store.state.hotel.roomQty,
          room_code: this.room.roomCode,
          rate_plan_code: this.room.ratePlan,
          tax_amount: this.room.taxAmount,
          gateway_fee: this.room.gatewayFee,
          currency_code: this.room.currencyCode,
          booking_fee: this.room.bookingFee
        }
      })
    },
    postContractedBody(stayId) {
      return JSON.stringify({
        hotel: {
          hotel_id: this.hotel.id,
          room_quantity: this.$store.state.hotel.roomQty,
          stay_id: stayId
        }
      })
    },
    async changeOrderItem() {
      if (this.disableButton || this.disableForSubmission) { return }
      this.disableForSubmission = true
      this.errs = null
      let res = null

      if (this.hotel.contracted) {
        res = await Api.addContractedToCart(
          this.orderItemId,
          this.postContractedBody(this.room.stayId)
        )
      } else {
        res = await Api.addH4HHotelToCart(
          this.orderItemId,
          this.postRetailBody(this.room.total)
        )
      }

      if (res.id) {
        document.getElementById('navCartLink').click()
      } else {
        this.errs = res.errors || this.$t('formPackage.error')
      }
      this.disableForSubmission = false
    }
  }
}
</script>
